module.exports = __webpack_public_path__ + "img/amex.3b4bcc95.png";